import useFetch from './useFetch'
import { apiEndpoints } from '../consts'

const useAuthMigrationSummary = () => {
  const { data, loading, error, refetch } = useFetch(apiEndpoints.adminAuthMigrationSummary, {
    errorMessage: 'Failed to load auth migration summary',
  })

  return {
    summary: data?.data || null,
    meta: data?.meta || null,
    loading,
    error,
    refetch,
  }
}

export default useAuthMigrationSummary
